var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBookOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.75C5.28831 2.75 6.9897 3.25114 8 3.87446C9.0103 3.25114 10.7117 2.75 12 2.75C12.7588 2.75 13.4883 2.87552 14.1666 3.1066C14.3664 3.17467 14.5 3.35673 14.5 3.56097V12.7172C14.5 12.8737 14.4212 13.0204 14.2887 13.1107C14.1562 13.201 13.9864 13.2237 13.8334 13.1716C13.2606 12.9765 12.6437 12.8701 12 12.8701C10.9381 12.8701 9.62833 13.309 8.65932 13.8714C8.25634 14.1052 7.74366 14.1052 7.34068 13.8714C6.37167 13.309 5.06191 12.8701 4 12.8701C3.35627 12.8701 2.73941 12.9765 2.16662 13.1716C2.01359 13.2237 1.84383 13.201 1.71131 13.1107C1.57879 13.0204 1.5 12.8737 1.5 12.7172V3.56097C1.5 3.35673 1.63358 3.17467 1.83338 3.1066C2.51171 2.87552 3.24118 2.75 4 2.75Z",
    fill: "#A614B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookOpen);
export default __webpack_public_path__ + "static/media/icon-book-open.ad50466a8212b92767ad5174743fe656.svg";
export { ForwardRef as ReactComponent };